import utils from '../libs/utils';
import axios from './axios';

// function axiosGet(url, params) {
//   return axios.get(`${url}?${utils.exchangeParams(params)}`);
// }
const MODULE_NAME = 'v1/erp-business-web';
export default {
  axios,
  planList(params) { //
    return axios.get(`${MODULE_NAME}/purchasePlan/list?${utils.exchangeParams(params)}`);
  },
  planInfo(params) { //
    return axios.get(`${MODULE_NAME}/purchasePlan/info?${utils.exchangeParams(params)}`);
  },
  planSave(params) { //
    return axios.post(`${MODULE_NAME}/purchasePlan/add`, utils.exchangeParams(params));
  },
  planAddAndSubmit(params) {
    return axios.post(`${MODULE_NAME}/purchasePlan/addAndSubmit`, utils.exchangeParams(params));
  },
  planLog(params) {
    return axios.get(`${MODULE_NAME}/purchasePlan/operateRecord?${utils.exchangeParams(params)}`);
  },
  planEditSave(params) { //
    return axios.post(`${MODULE_NAME}/purchasePlan/edit`, utils.exchangeParams(params));
  },
  planSubmit(params) { //
    return axios.post(`${MODULE_NAME}/purchasePlan/submit`, utils.exchangeParams(params));
  },
  planDelete(params) {
    return axios.post(`${MODULE_NAME}/purchasePlan/delete`, utils.exchangeParams(params));
  },
  medicineInfo(params) { //
    return axios.get(`${MODULE_NAME}/purchasePlan/medicineInfo?${utils.exchangeParams(params)}`);
  },
  medicineInfoList(params) { //
    return axios.get(`${MODULE_NAME}/purchasePlan/listMedicineInfo?${utils.exchangeParams(params)}`);
  },
  orderList(params) { //
    return axios.get(`${MODULE_NAME}/purchaseOrder/list?${utils.exchangeParams(params)}`);
  },
  orderListExport(params) { // 订单明细导出
    return axios.get(`${MODULE_NAME}/purchaseOrder/list/download?${utils.exchangeParams(params)}`);
  },
  orderInfo(params) { //
    return axios.get(`${MODULE_NAME}/purchaseOrder/info?${utils.exchangeParams(params)}`);
  },
  cancelOrder(params) { //
    return axios.post(`${MODULE_NAME}/purchaseOrder/cancel`, utils.exchangeParams(params));
  },
  receiptManage(params) { //
    return axios.get(`${MODULE_NAME}/purchaseReceipt/todoReceiptList?${utils.exchangeParams(params)}`);
  },
  receiptAdd(params) {
    return axios.post(`${MODULE_NAME}/purchaseReceipt/add`, utils.exchangeParams(params));
  },
  receiptUpdateReportUrl(params) {
    return axios.post(`${MODULE_NAME}/purchaseReceipt/updateReportUrl`, utils.exchangeParams(params));
  },
  receiptDetail(params) { //
    return axios.get(`${MODULE_NAME}/purchaseReceipt/todoReceiptInfo?${utils.exchangeParams(params)}`);
  },
  receiptList(params) { //
    return axios.get(`${MODULE_NAME}/purchaseReceipt/list?${utils.exchangeParams(params)}`);
  },
  receiptInfo(params) { //
    return axios.get(`${MODULE_NAME}/purchaseReceipt/info?${utils.exchangeParams(params)}`);
  },
  todoInspectionList(params) {
    return axios.get(`${MODULE_NAME}/purchaseInspection/todoInspectionList?${utils.exchangeParams(params)}`);
  },
  todoInspectionInfo(params) {
    return axios.get(`${MODULE_NAME}/purchaseInspection/todoInspectionInfo?${utils.exchangeParams(params)}`);
  },
  todoInspectionAdd(params) {
    return axios.post(`${MODULE_NAME}/purchaseInspection/add`, utils.exchangeParams(params));
  },
  inspectionList(params) { //
    return axios.get(`${MODULE_NAME}/purchaseInspection/list?${utils.exchangeParams(params)}`);
  },
  inspectionListDown(params) { //
    return axios.get(`${MODULE_NAME}/purchaseInspection/list/download?${utils.exchangeParams(params)}`);
  },
  printInspectionList(params) { //
    return axios.get(`${MODULE_NAME}/purchaseInspection/infoList?${utils.exchangeParams(params)}`);
  },
  inspectionInfo(params) { //
    return axios.get(`${MODULE_NAME}/purchaseInspection/info?${utils.exchangeParams(params)}`);
  },

  rejectionList(params) { //
    return axios.get(`${MODULE_NAME}/purchaseRejection/list?${utils.exchangeParams(params)}`);
  },
  rejectionInfo(params) { //
    return axios.get(`${MODULE_NAME}/purchaseRejection/info?${utils.exchangeParams(params)}`);
  },
  planStats(params) { // 采购计划明细列表
    return axios.get(`${MODULE_NAME}/purchaseStats/purchasePlan?${utils.exchangeParams(params)}`);
  },
  planStatsDownload(params) { // 采购计划明细列表导出
    return axios.get(`${MODULE_NAME}/purchaseStats/purchasePlan/download?${utils.exchangeParams(params)}`);
  },
  orderStats(params) { // 采购订单列表
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseOrder?${utils.exchangeParams(params)}`);
  },
  orderStatsDownload(params) { // 采购订单列表导出
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseOrder/download?${utils.exchangeParams(params)}`);
  },
  receiptStats(params) { // 采购收货列表
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseReceipt?${utils.exchangeParams(params)}`);
  },
  receiptStatsDownload(params) { // 采购收货列表导出
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseReceipt/download?${utils.exchangeParams(params)}`);
  },
  inspectionStats(params) { // 采购验收列表
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseInspection?${utils.exchangeParams(params)}`);
  },
  inspectionStatsDownload(params) { // 采购验收列表导出
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseInspection/download?${utils.exchangeParams(params)}`, {
      // responseType: 'blob',
    });
  },
  inspectionDrawerStats(params) { // 清装斗记录列表
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseDrawerDetail?${utils.exchangeParams(params)}`);
  },
  inspectionDrawerStatsDownload(params) { // 清装斗记录列表导出
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseDrawerDetail/download?${utils.exchangeParams(params)}`);
  },
  rejectionStats(params) { // 拒收明细列表
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseRejection?${utils.exchangeParams(params)}`);
  },
  rejectionStatsDownload(params) { // 拒收明细导出
    return axios.get(`${MODULE_NAME}/purchaseStats/purchaseRejection/download?${utils.exchangeParams(params)}`);
  },
  planGoodsList(params) { //
    return axios.get(`${MODULE_NAME}/purchasePlan/listPurchaseGoods?${utils.exchangeParams(params)}`);
  },
  checkProdDate(params) { // 检查收货商品生产日期
    return axios.get(`${MODULE_NAME}/purchaseReceipt/checkProdDate?${utils.exchangeParams(params)}`);
  },
  getPlanStatsSummary(params) { // 采购明细汇总信息
    return axios.get(`${MODULE_NAME}/purchaseStats/getPlanStatsSummary?${utils.exchangeParams(params)}`);
  },
  getOrderStatsSummary(params) { // 采购订单汇总信息
    return axios.get(`${MODULE_NAME}/purchaseStats/getOrderStatsSummary?${utils.exchangeParams(params)}`);
  },
  getReceiptStatsSummary(params) { // 采购收货单汇总信息
    return axios.get(`${MODULE_NAME}/purchaseStats/getReceiptStatsSummary?${utils.exchangeParams(params)}`);
  },
  getInspectionStatsSummary(params) { // 采购验收单汇总信息
    return axios.get(`${MODULE_NAME}/purchaseStats/getInspectionStatsSummary?${utils.exchangeParams(params)}`);
  },
  getRejectionStatsSummary(params) { // 采购拒收单汇总信息
    return axios.get(`${MODULE_NAME}/purchaseStats/getRejectionStatsSummary?${utils.exchangeParams(params)}`);
  },
  getDrawerInfo(params) { // 获取斗信息
    return axios.get(`${MODULE_NAME}/purchaseInspection/drawer/info?${utils.exchangeParams(params)}`);
  },
  getlistInspectRefundReport(params) {
    return axios.get(`${MODULE_NAME}/purchaseStats/listInspectRefundReport?${utils.exchangeParams(params)}`);
  },
  downloadListInspectRefundReport(params) {
    return axios.get(`${MODULE_NAME}/purchaseStats/listInspectRefundReport/download?${utils.exchangeParams(params)}`);
  },
  todoInspectionDrawerAdd(params) {
    return axios.post(`${MODULE_NAME}/purchaseInspection/drawer/add`, utils.exchangeParams(params));
  },
  submitUDI(params) {
    return axios.post(`${MODULE_NAME}/udi/submit`, utils.exchangeParams(params));
  },
};
